import { Stack, Typography, Pagination } from "@mui/material";
import { Strings } from "@app/constants";
import { MyOrdersPaginationProps } from "../types";

const MyOrdersPagination = ({
  data,
  page,
  handleChangePage,
  theme,
}: MyOrdersPaginationProps) => {
  const total = Number(data?.pagination?.total);
  const currentPage = Number(data?.pagination?.page);
  const limit = Number(data?.pagination?.limit);

  const totalPages = Math.ceil(total / limit);
  const start = (currentPage - 1) * limit + 1;
  const end = Math.min(currentPage * limit, total);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      px={2}
      py={1}
      borderTop={`1px solid ${theme.palette.common.white}`}
      sx={{ marginLeft: "auto" }}
    >
      <Typography sx={{ marginLeft: "auto" }}>
        Showing {start} to {end} of {total} {Strings.productListPage.entries}
      </Typography>

      <Pagination
        count={totalPages}
        page={page}
        onChange={handleChangePage}
        color="primary"
        shape="rounded"
        size="small"
        siblingCount={0}
        boundaryCount={1}
        sx={{
          "& .MuiPaginationItem-root": {
            minWidth: 25,
            height: 25,
            fontSize: 14,
          },
          "& .MuiPaginationItem-ellipsis": {
            mx: 1,
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            borderRadius: "6px",
            fontWeight: 500,
          },
        }}
      />
    </Stack>
  );
};

export { MyOrdersPagination };
